import { render } from "./Installations.vue?vue&type=template&id=629b8d26"
import script from "./Installations.vue?vue&type=script&lang=js"
export * from "./Installations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__